import { z } from 'zod';

export const RuntimeConfigSchema = z.object({
  keycloakUrl: z.string().min(1),
  keycloakRealm: z.string().min(1),
  keycloakClientId: z.string().min(1),
  apiBaseUrl: z.string(), // '' = même origine
  appEnv: z.enum(['dev', 'prod']),
});

export type RuntimeConfig = z.infer<typeof RuntimeConfigSchema>;

let resolved: RuntimeConfig | null = null;

/**
 * Lit /config.json et le valide. Échoue BRUYAMMENT (throw) : pas de valeur par défaut.
 * À appeler AVANT app.mount(), avant setupHttp() et avant initKeycloak().
 */
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Configuration runtime illisible : /config.json a répondu ${response.status}.`);
  }

  let raw: unknown;
  try {
    raw = await response.json();
  } catch {
    throw new Error('Configuration runtime invalide : /config.json n\'est pas un JSON valide.');
  }

  const parsed = RuntimeConfigSchema.safeParse(raw);
  if (!parsed.success) {
    const details = parsed.error.issues
      .map((issue) => `${issue.path.join('.') || '(racine)'} : ${issue.message}`)
      .join(' ; ');
    throw new Error(`Configuration runtime invalide (/config.json) — ${details}`);
  }

  resolved = parsed.data;
  return resolved;
}

/** Config résolue — appelable seulement après loadRuntimeConfig(). Throw sinon. */
export function runtimeConfig(): RuntimeConfig {
  if (!resolved) {
    throw new Error('runtimeConfig() appelé avant loadRuntimeConfig().');
  }
  return resolved;
}
